// Support chat for visitors who are not logged in (SUP-03): loads the self-contained widget public/nm-chat.js
// (also used by the static marketing pages). The widget hides itself once a token exists, so a client-side login
// (e.g. the duel "claim your account" flow) hands over to the in-app Plutus + Support dock without a reload.
import { useEffect } from 'react';

const API_BASE = process.env.REACT_APP_API_BASE || '';

export default function VisitorChat() {
  useEffect(() => {
    if (window.__nmChat || document.querySelector('script[data-nm-chat]')) return;
    const s = document.createElement('script');
    s.src = `${process.env.PUBLIC_URL || ''}/nm-chat.js`;
    s.defer = true;
    s.setAttribute('data-nm-chat', '1');
    // same origin in production; a local backend in development
    if (API_BASE && !API_BASE.startsWith(window.location.origin)) s.setAttribute('data-api', API_BASE);
    document.body.appendChild(s);
  }, []);
  return null;
}
